import differenceInSeconds from 'date-fns/differenceInSeconds'
import parseISO from 'date-fns/parseISO'
import * as React from 'react'

import {formatDuration} from '../../../../../utils/dateTimeUtils'

import type {Props} from './BuildLogOverviewDuration.types'

export default function BuildLogOverviewDuration({startDate, finishDate}: Props) {
  if (startDate == null || finishDate == null) {
    return null
  }

  const duration = formatDuration(differenceInSeconds(parseISO(finishDate), parseISO(startDate)), {
    alwaysShowSeconds: true,
  })
  return <span>{`Duration: ${duration}`}</span>
}
